import React from 'react';

const WebTechFloater = () => {
  return (
    <a
      href="https://web-techservices.com"
      target="_blank"
      rel="noopener noreferrer"
      className="hidden lg:flex fixed bottom-4 left-4 z-50 bg-black/80 text-white px-4 py-2 rounded-lg text-xs font-medium backdrop-blur-sm hover:bg-black/90 transition-all shadow-lg items-center gap-2"
      data-testid="webtech-floater"
    >
      <svg className="w-4 h-4 text-[#3a87fe]" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
      Web-Techservices.com AI
    </a>
  );
};

export default WebTechFloater;
